import { useProduct } from '~/modules/product/composables/useProduct';
import type { SelectedColorId } from '~/declaration/traits';

export default function useTypeBySelectedColor(selectedColorId: SelectedColorId): string | null {
  const { productData } = useProduct();
  const typeMap = productData?.traits?.types?.typeMap;

  if (!typeMap) return null;

  const typeObject = Object.entries(typeMap).find(([, typeValue]) =>
    Object.entries(typeValue.colors || {}).some(([, colorId]) => colorId === selectedColorId),
  );

  return typeObject?.[0] || null;
}
